/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiPaginatedResponseOfSavedSearchResponse } from '../model';
// @ts-ignore
import { ApiResponseOfSavedSearchResponse } from '../model';
// @ts-ignore
import { SavedSearchBody } from '../model';
// @ts-ignore
import { SavedSearchType } from '../model';
/**
 * SavedSearchesApi - axios parameter creator
 * @export
 */
export const SavedSearchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (savedSearchBody: SavedSearchBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedSearchBody' is not null or undefined
            assertParamExists('create', 'savedSearchBody', savedSearchBody)
            const localVarPath = `/api/v1/savedSearches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savedSearchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SavedSearchType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated: async (limit?: number, page?: number, type?: SavedSearchType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/savedSearches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (savedSearchId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedSearchId' is not null or undefined
            assertParamExists('remove', 'savedSearchId', savedSearchId)
            const localVarPath = `/api/v1/savedSearches/{savedSearchId}`
                .replace(`{${"savedSearchId"}}`, encodeURIComponent(String(savedSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (savedSearchId: string, savedSearchBody: SavedSearchBody, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedSearchId' is not null or undefined
            assertParamExists('update', 'savedSearchId', savedSearchId)
            // verify required parameter 'savedSearchBody' is not null or undefined
            assertParamExists('update', 'savedSearchBody', savedSearchBody)
            const localVarPath = `/api/v1/savedSearches/{savedSearchId}`
                .replace(`{${"savedSearchId"}}`, encodeURIComponent(String(savedSearchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savedSearchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SavedSearchesApi - functional programming interface
 * @export
 */
export const SavedSearchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SavedSearchesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(savedSearchBody: SavedSearchBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSavedSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(savedSearchBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SavedSearchType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaginated(limit?: number, page?: number, type?: SavedSearchType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPaginatedResponseOfSavedSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaginated(limit, page, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(savedSearchId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(savedSearchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(savedSearchId: string, savedSearchBody: SavedSearchBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfSavedSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(savedSearchId, savedSearchBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SavedSearchesApi - factory interface
 * @export
 */
export const SavedSearchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SavedSearchesApiFp(configuration)
    return {
        /**
         * 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(savedSearchBody: SavedSearchBody, options?: any): AxiosPromise<ApiResponseOfSavedSearchResponse> {
            return localVarFp.create(savedSearchBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {SavedSearchType} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaginated(limit?: number, page?: number, type?: SavedSearchType, options?: any): AxiosPromise<ApiPaginatedResponseOfSavedSearchResponse> {
            return localVarFp.getPaginated(limit, page, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(savedSearchId: string, options?: any): AxiosPromise<void> {
            return localVarFp.remove(savedSearchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedSearchId 
         * @param {SavedSearchBody} savedSearchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(savedSearchId: string, savedSearchBody: SavedSearchBody, options?: any): AxiosPromise<ApiResponseOfSavedSearchResponse> {
            return localVarFp.update(savedSearchId, savedSearchBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SavedSearchesApi - interface
 * @export
 * @interface SavedSearchesApi
 */
export interface SavedSearchesApiInterface {
    /**
     * 
     * @param {SavedSearchBody} savedSearchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApiInterface
     */
    create(savedSearchBody: SavedSearchBody, options?: any): AxiosPromise<ApiResponseOfSavedSearchResponse>;

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {SavedSearchType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApiInterface
     */
    getPaginated(limit?: number, page?: number, type?: SavedSearchType, options?: any): AxiosPromise<ApiPaginatedResponseOfSavedSearchResponse>;

    /**
     * 
     * @param {string} savedSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApiInterface
     */
    remove(savedSearchId: string, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {string} savedSearchId 
     * @param {SavedSearchBody} savedSearchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApiInterface
     */
    update(savedSearchId: string, savedSearchBody: SavedSearchBody, options?: any): AxiosPromise<ApiResponseOfSavedSearchResponse>;

}

/**
 * SavedSearchesApi - object-oriented interface
 * @export
 * @class SavedSearchesApi
 * @extends {BaseAPI}
 */
export class SavedSearchesApi extends BaseAPI implements SavedSearchesApiInterface {
    /**
     * 
     * @param {SavedSearchBody} savedSearchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApi
     */
    public create(savedSearchBody: SavedSearchBody, options?: any) {
        return SavedSearchesApiFp(this.configuration).create(savedSearchBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {number} [page] 
     * @param {SavedSearchType} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApi
     */
    public getPaginated(limit?: number, page?: number, type?: SavedSearchType, options?: any) {
        return SavedSearchesApiFp(this.configuration).getPaginated(limit, page, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} savedSearchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApi
     */
    public remove(savedSearchId: string, options?: any) {
        return SavedSearchesApiFp(this.configuration).remove(savedSearchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} savedSearchId 
     * @param {SavedSearchBody} savedSearchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavedSearchesApi
     */
    public update(savedSearchId: string, savedSearchBody: SavedSearchBody, options?: any) {
        return SavedSearchesApiFp(this.configuration).update(savedSearchId, savedSearchBody, options).then((request) => request(this.axios, this.basePath));
    }
}
